import Choices from 'choices.js';

export default {
    props: {
        heading: String,
        showFilterToggle: Boolean,
    },

    data() {
        return {
            searchBy: 'manufacturer',
            searchValue: null,
        };
    },

    mounted() {
        // Initiate Choices.js
        return new Choices(this.$el.querySelector('select'), {
            searchEnabled: false,
            itemSelectText: '',
        });
    },

    computed: {

    },

    methods: {
        /**
         * Data to be emitted to parent
         * @param {string} value Search query
         */
        emitData(value) {
            // Gather data
            const data = {
                key: 'search',
                values: { [this.searchBy]: value },
            };

            // Emit to parent
            return this.$emit('search', data);
        },

        /**
         * Form submit
         */
        onSubmit() {
            // If empty, stop.
            if (!this.searchValue) return false;
            // Fire emitData function
            return this.emitData(this.searchValue);
        },

        /**
         * Button click
         */
        handleClick() {
            // Emit to parent
            return this.$emit('toggle-view-filters');
        },
    },

    watch: {
        searchValue(val) {
            // If search value is empty, Fire emitData function
            if (val === '') {
                this.emitData('');
            }
        },
    },

    template: `
        <div>
            <form class="search-filter search-filter--products" v-on:submit.prevent="onSubmit">
                <div class="search-filter__section-top">
                    <h1 class="h3 search-filter__heading">{{ heading }}</h1>
                    <div class="search-filter__input-wrap">
                        <input
                            type="text"
                            name="search"
                            :placeholder="'Search by ' + searchBy"
                            class="search-filter__search-input"
                            v-model="searchValue">
                        <svg class="search-filter__search-icon icon" v-on:click="onSubmit">
                            <use xlink:href="#search"></use>
                        </svg>
                    </div>

                    <div class="dropdown dropdown--products dropdown--icon-circle-chevron">
                        <select v-model="searchBy">
                            <option value="manufacturer">Manufacturer</option>
                            <option value="model">Model number</option>
                        </select>
                    </div>

                    <a v-if="showFilterToggle" class="iconlink" @click="handleClick">
                        <svg class="icon" viewBox="0 0 28 17" xmlns="http://www.w3.org/2000/svg">
                            <g fill-rule="nonzero" stroke="#FFF" stroke-width="3" fill="none" stroke-linecap="round">
                            <path d="M9.406 15.5H19.5M6.405 8.5h16.19M2.393 1.5H26.5"/>
                            </g>
                        </svg>
                    </a>
                </div>
            </form>
        </div>
    `,
};
